import { useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import Register from "../components/login-and-regsister/register-form";
import LoginForm from "../components/login-and-regsister/login-form";
import { auth } from "../utils/fipresConfig";
import "../style/authentication.css";

export default function Authentication() {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/"); // إعادة التوجيه إلى الصفحة الرئيسية أو أي صفحة أخرى
    }
  }, [user, navigate]);

  if (loading) {
    return <div>Loading...</div>; // يمكنك تخصيص رسالة التحميل هنا
  }

  return (
    <>
      <div className="auth-container">
        <div className="auth_content">
          <div className="auth-form-style">
            <div className="auth-right">
              <div className="auth-form">
                <div className="text-center">
                  <h6>
                    <span>Log In</span> <span>Sign Up</span>
                  </h6>
                  <input
                    type="checkbox"
                    className="auth-checkbox"
                    id="reg-log"
                  />
                  <label className="auth-label" htmlFor="reg-log"></label>
                  <div className="card-3d-wrap">
                    <div className="card-3d-wrapper">
                      <div className="card-front">
                        <div className="center-wrap">
                          <h4 className="heading">Log In</h4>
                          <LoginForm />
                        </div>
                      </div>
                      <div className="card-back">
                        <div className="center-wrap">
                          <h4 className="heading">Sign Up</h4>
                          <Register />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}